@if (candidateList?.length) {
	<div class="relative">
		<div class="flex grid-rows-1 flex-row items-center gap-4">
			<button
				class="button-nav h-[24px] !min-w-6 border bg-teal !p-0"
				(click)="onPrev()"
				mat-stroked-button
				[disabled]="current === 0"
				aria-label="Previous candidate"
			>
				<mat-icon class="pl-1 !align-baseline">chevron_left</mat-icon>
			</button>
			<div class="text-lg font-bold leading-6 text-violet">
				{{ candidateList[current].candidateDetails.name || "—" }}
				<span class="ml-2 text-sm text-gray-500"> ({{ current + 1 }} / {{ candidateList.length }}) </span>
			</div>
			<button
				(click)="onNext()"
				class="button-nav h-[24px] !min-w-6 border bg-teal !p-0"
				mat-stroked-button
				[disabled]="current === candidateList.length - 1"
				aria-label="Next candidate"
			>
				<mat-icon class="pl-1 !align-baseline">chevron_right</mat-icon>
			</button>
		</div>
		<div class="slide-wrapper">
			@for (candidate of candidateList; track trackCandidate(i, candidate); let i = $index) {
				<app-cbta-form-navigator [isIn]="current === i" [left]="isLeftTransition(i)">
					@if (isTs1V3ReportSummary(candidate) && ts1PreviewContexts[i]) {
						@if (ts1V3PageIndex === 0 || current !== i) {
							<app-ts1-v3-report-summary
								[reportSummary]="candidate"
								[previewContext]="ts1PreviewContexts[i]"
								[candidateId]="candidateIds[i]"
							></app-ts1-v3-report-summary>
						}
						@if (current === i && ts1V3PageIndex === 1 && hasTs1V3ManeuverBreakdown(candidate)) {
							<app-ts1-v3-maneuver-breakdown
								[reportSummary]="candidate"
								[previewContext]="ts1PreviewContexts[i]"
								[maneuverBreakdownView]="candidate.ts1V3PreviewSummary?.maneuverBreakdownView ?? []"
							></app-ts1-v3-maneuver-breakdown>
						}
						@if (current === i) {
							<div class="mt-[40px] flex items-center gap-4 px-6">
								<button
									[disabled]="ts1V3PageIndex === 0"
									(click)="goBackTs1V3()"
									mat-stroked-button
									class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black disabled:opacity-50"
								>
									Back
								</button>
								@if (ts1V3PageIndex === 0 && hasTs1V3ManeuverBreakdown(candidate)) {
									<button
										(click)="goNextTs1V3()"
										mat-stroked-button
										class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black"
									>
										Next
									</button>
								}
								<div class="flex-1"></div>
							</div>
						}
					}
					@if (!isTs1V3ReportSummary(candidate) || !ts1PreviewContexts[i]) {
						<div class="my-8 flex items-center justify-between px-0 lg:px-6">
							<h2 class="text-center !text-lg !font-bold !leading-6">{{ summaryReportTitle }}</h2>
							<div class="flex size-28 items-center justify-center">
								<img src="{{ candidate?.logo }}" alt="AOC" class="scale-150" />
							</div>
						</div>
						<mat-stepper id="report-summary-stepper" #stepper>
							<!-- STEP 1: Summary -->
							<mat-step>
								<div id="summary-report" #summaryReport class="avoid-break break-after w-full">
									<div class="grid grid-cols-2 gap-8 p-8 pt-4">
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Training Date</label>
											<div class="form-value">
												{{ formatSummaryDate($safeNavigationMigration(candidate?.trainingDate)) }}
											</div>
										</div>
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Session</label>
											<div class="form-value">
												{{
													join($safeNavigationMigration(candidate?.candidateDetails?.candidateSessionConfigurations))
												}}
											</div>
										</div>
									</div>
									<!-- Candidate Details -->
									<div
										class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
									>
										Candidate Details
									</div>
									<div class="grid grid-cols-2 gap-8 p-8 pt-4">
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Name</label>
											<div class="form-value">
												{{ candidate?.candidateDetails?.name ?? "-" }}
											</div>
										</div>
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Rank</label>
											<div class="form-value">
												{{ candidate?.candidateDetails?.rank ?? "-" }}
											</div>
										</div>
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Staff Number</label>
											<div class="form-value">
												{{ candidate?.candidateDetails?.staffNumber ?? "-" }}
											</div>
										</div>
										@if (!isCC) {
											@if (isTS1) {
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">Trainee Profile</label>
													<div class="form-value">
														{{ candidate?.candidateDetails?.trainingProfile || "-" }}
													</div>
												</div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">License Type</label>
													<div class="form-value">
														{{ candidate?.candidateDetails?.licenseType || "-" }}
													</div>
												</div>
											} @else {
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">License Type</label>
													<div class="form-value">
														{{ candidate?.candidateDetails?.licenseType || "-" }}
													</div>
												</div>
											}
										}
										@if (!isCC) {
											<div class="form-display flex flex-col gap-2">
												<label class="form-label">License Number</label>
												<div class="form-value">
													{{ candidate?.candidateDetails?.licenseNumber || "-" }}
												</div>
											</div>
											<div class="form-display flex flex-col gap-2">
												<label class="form-label">License Expiry Date</label>
												<div class="form-value">
													{{
														candidate?.candidateDetails?.licenseNumber
															? formatSummaryDate(
																	$safeNavigationMigration(candidate?.candidateDetails?.licenseExpiryDate)
																)
															: "-"
													}}
												</div>
											</div>
										}
									</div>
									@if (!isCC) {
										<app-flight-simulator-summary-fields-v2
											[details]="$safeNavigationMigration(candidate?.flightSimulatorDetails)"
										/>
									}
									@if (isNoGradingSignOffForm(candidate) && hasRecommendationSummary(candidate)) {
										@let rec = candidate.recommendation;
										@let isTraining = isRecommendationTraining(rec);
										<div class="mt-6">
											<div class="grid grid-rows-1 gap-4">
												<div
													class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
												>
													Recommendation by Instructor/Examiner
												</div>
											</div>
											<div class="grid grid-cols-2 gap-8 p-8 pt-4">
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">Is this a training or check session?</label>
													<div class="form-value">
														{{ recommendationSessionLabel(rec) }}
													</div>
												</div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label"> {{ isTraining ? "Training" : "Check" }} Session Completed </label>
													<div class="form-value">
														{{ formatRecommendationYesNo($safeNavigationMigration(rec?.is_complete)) }}
													</div>
												</div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label"> {{ isTraining ? "Training" : "Check" }} Objectives Are Met </label>
													<div class="form-value">
														{{ formatRecommendationObjective(rec) }}
													</div>
												</div>
												@if (isTraining) {
													<div class="form-display flex flex-col gap-2">
														<label class="form-label">Cleared for Check</label>
														<div class="form-value">
															{{ formatRecommendationClearance(rec) }}
														</div>
													</div>
												}
											</div>
										</div>
									}
									<div class="grid grid-rows-1 gap-4">
										<div
											class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
										>
											@if (isNoGradingSignOffForm(candidate)) {
												Sign Off
											} @else {
												Session Details
											}
										</div>
									</div>
									@if (!isCandidateCC(candidate) && !isNoGradingSignOffForm(candidate)) {
										<div
											class="mt-4 grid grid-cols-2 gap-x-10 gap-y-6 bg-[#F6FAFF] p-8 lg:gap-x-16 lg:gap-y-16 lg:bg-[#FBFCFE]"
										>
											<div>
												<div class="rating-label">Grading A : How Many</div>
												<div class="rating-box">
													<div
														[class.active]="
															$safeNavigationMigration(candidate?.sessionDetails?.ratingA) === null ||
															candidate?.sessionDetails?.ratingA === 1
														"
														class="rating-box-item"
													>
														1
													</div>
													<div [class.active]="candidate?.sessionDetails?.ratingA === 2" class="rating-box-item">2</div>
													<div [class.active]="candidate?.sessionDetails?.ratingA === 3" class="rating-box-item">3</div>
													<div [class.active]="candidate?.sessionDetails?.ratingA === 4" class="rating-box-item">4</div>
													<div [class.active]="candidate?.sessionDetails?.ratingA === 5" class="rating-box-item">5</div>
												</div>
											</div>
											<div>
												<div class="rating-label">Grading B : How Often</div>
												<div class="rating-box">
													<div
														[class.active]="
															$safeNavigationMigration(candidate?.sessionDetails?.ratingB) === null ||
															candidate?.sessionDetails?.ratingB === 1
														"
														class="rating-box-item"
													>
														1
													</div>
													<div [class.active]="candidate?.sessionDetails?.ratingB === 2" class="rating-box-item">2</div>
													<div [class.active]="candidate?.sessionDetails?.ratingB === 3" class="rating-box-item">3</div>
													<div [class.active]="candidate?.sessionDetails?.ratingB === 4" class="rating-box-item">4</div>
													<div [class.active]="candidate?.sessionDetails?.ratingB === 5" class="rating-box-item">5</div>
												</div>
											</div>
											<div>
												<div class="rating-label">Grading C : TEM Safety Outcome</div>
												<div class="rating-box">
													<div
														[class.active]="
															$safeNavigationMigration(candidate?.sessionDetails?.ratingC) === null ||
															candidate?.sessionDetails?.ratingC === 1
														"
														class="rating-box-item"
													>
														1
													</div>
													<div [class.active]="candidate?.sessionDetails?.ratingC === 2" class="rating-box-item">2</div>
													<div [class.active]="candidate?.sessionDetails?.ratingC === 3" class="rating-box-item">3</div>
													<div [class.active]="candidate?.sessionDetails?.ratingC === 4" class="rating-box-item">4</div>
													<div [class.active]="candidate?.sessionDetails?.ratingC === 5" class="rating-box-item">5</div>
												</div>
											</div>
											<div class="final-rating">
												<div class="rating-label">Grading D : Final Grading</div>
												<div class="rating-box">
													<div
														[class.active]="
															$safeNavigationMigration(candidate?.sessionDetails?.finalRating) === null ||
															candidate?.sessionDetails?.finalRating === 1
														"
														class="rating-box-item"
													>
														1
													</div>
													<div [class.active]="candidate?.sessionDetails?.finalRating === 2" class="rating-box-item">
														2
													</div>
													<div [class.active]="candidate?.sessionDetails?.finalRating === 3" class="rating-box-item">
														3
													</div>
													<div [class.active]="candidate?.sessionDetails?.finalRating === 4" class="rating-box-item">
														4
													</div>
													<div [class.active]="candidate?.sessionDetails?.finalRating === 5" class="rating-box-item">
														5
													</div>
													<div class="rating-border"></div>
												</div>
											</div>
										</div>
									} @else if (isCandidateCC(candidate)) {
										<div class="flex items-center justify-center bg-[#F6FAFF] py-16 lg:bg-[#FBFCFE]">
											<div class="mx-auto">
												<div class="rating-box">
													<div
														class="rating-box-item"
														[ngClass]="{
															'!bg-[#FF5151] !text-white':
																!candidate?.sessionDetails?.ratingC || candidate?.sessionDetails?.ratingC === 1,
														}"
													>
														1
													</div>
													<div
														class="rating-box-item"
														[ngClass]="{
															'!bg-[#F9AC51] !text-white': candidate?.sessionDetails?.ratingC === 2,
														}"
													>
														2
													</div>
													<div
														class="rating-box-item"
														[ngClass]="{
															'!bg-[#FFC738] !text-white': candidate?.sessionDetails?.ratingC === 3,
														}"
													>
														3
													</div>
													<div
														class="rating-box-item"
														[ngClass]="{
															'!bg-[#52C280] !text-white': candidate?.sessionDetails?.ratingC === 4,
														}"
													>
														4
													</div>
													<div
														class="rating-box-item"
														[ngClass]="{
															'!bg-[#49A06C] !text-white': candidate?.sessionDetails?.ratingC === 5,
														}"
													>
														5
													</div>
												</div>
											</div>
										</div>
									}
									@if (!isNoGradingSignOffForm(candidate) && hasRecommendationSummary(candidate)) {
										@let rec = candidate.recommendation;
										@let isTraining = isRecommendationTraining(rec);
										<div class="mt-6">
											<div class="grid grid-rows-1 gap-4">
												<div
													class="flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
												>
													Recommendation by Instructor/Examiner
												</div>
											</div>
											<div class="grid grid-cols-2 gap-8 p-8 pt-4">
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">Is this a training or check session?</label>
													<div class="form-value">
														{{ recommendationSessionLabel(rec) }}
													</div>
												</div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label"> {{ isTraining ? "Training" : "Check" }} Session Completed </label>
													<div class="form-value">
														{{ formatRecommendationYesNo($safeNavigationMigration(rec?.is_complete)) }}
													</div>
												</div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label"> {{ isTraining ? "Training" : "Check" }} Objectives Are Met </label>
													<div class="form-value">
														{{ formatRecommendationObjective(rec) }}
													</div>
												</div>
												@if (isTraining) {
													<div class="form-display flex flex-col gap-2">
														<label class="form-label">Cleared for Check</label>
														<div class="form-value">
															{{ formatRecommendationClearance(rec) }}
														</div>
													</div>
												}
											</div>
										</div>
									}
									<div
										class="grid grid-cols-2 gap-8 p-8"
										[class.mt-6]="!isNoGradingSignOffForm(candidate)"
									>
										<div class="space-y-8">
											<div class="form-display flex flex-col gap-2">
												<label class="form-label">Instructor Name</label>
												<div class="form-value">
													{{ candidate?.sessionDetails?.instructorName }}
												</div>
											</div>
											@if (!isCandidateCC(candidate)) {
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">License Number</label>
													<div class="form-value">
														{{ candidate?.examinerNumber ?? "-" }}
													</div>
												</div>
											}
										</div>
										<div class="form-display flex flex-col gap-2">
											<label class="form-label">Instructor Signature</label>
											<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
												@if (resolveSignatureImage(candidate?.sessionDetails?.instructorSignature)) {
													<img
														[src]="resolveSignatureImage(candidate?.sessionDetails?.instructorSignature)"
														alt="Signature"
														class="h-full"
													/>
												}
												<span class="text-sm font-medium">{{ candidate?.signOffDate }}</span>
											</div>
										</div>
									</div>
									@if (showCandidateSignature(candidate)) {
										<div class="my-4 h-0.5 w-full bg-[#CFE3FF]"></div>
										<div class="grid grid-cols-2 gap-8 p-8">
											<div>
												<div class="form-display flex flex-col gap-2">
													<label class="form-label">Candidate name</label>
													<div class="form-value">
														{{ candidate?.candidateDetails?.name }}
													</div>
												</div>
											</div>
											<div class="form-display flex flex-col gap-2">
												<label class="form-label">Candidate Signature</label>
												<div class="flex h-24 w-72 flex-col items-center gap-4 bg-[#F6FAFF]">
													@if (resolveSignatureImage(candidate?.sessionDetails?.traineeSignature)) {
														<img
															[src]="resolveSignatureImage(candidate?.sessionDetails?.traineeSignature)"
															alt="Signature"
															class="h-full"
														/>
													}
													<span class="text-sm font-medium">{{ candidate?.signOffDate }}</span>
												</div>
											</div>
										</div>
									}
									<div id="instructor-notes" #instructorNotes class="avoid-break break-after mt-5">
										<!-- Instructor Notes/Comments -->
										<div
											class="mb-6 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
										>
											Instructor Notes/Comments
										</div>
										<div class="mt-8">
											<div class="text-sm font-medium text-grey-60">Summary</div>
											<div class="mt-4 min-h-40 rounded-md border border-blue-20 px-8 py-6 text-[85%] uppercase">
												<app-cbta-rating-summary-comments
													[comments]="candidate?.trainerExaminerNotes?.summary ?? []"
												></app-cbta-rating-summary-comments>
											</div>
										</div>
										<div class="mt-8">
											<div class="text-sm font-medium text-grey-60">Other Training & Observations</div>
											<div class="mt-4 min-h-40 rounded-md border border-blue-20 px-8 py-6">
												@for (comment of candidate?.trainerExaminerNotes?.otherTrainingAndObservations; track comment) {
													@if (isTS1) {
														@if (!helperService.isEmptyComment(comment)) {
															<p class="mb-1 whitespace-pre-wrap break-words text-left font-medium uppercase">
																{{ comment + `\n` }}
															</p>
														}
													} @else {
														<p class="mb-1 whitespace-pre-wrap break-words text-left font-medium uppercase">
															{{ comment + `\n` || "" | uppercase }}
														</p>
													}
												}
											</div>
										</div>
									</div>
								</div>
							</mat-step>
							<!-- STEP 2: Charts -->
							@if (isTS1 || isTS3 || isCC) {
								<mat-step>
									<div
										class="mb-6 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
									>
										Performance Metrics
									</div>
									<div class="mb-16">
										<div class="mb-4 border-y border-[#CFE3FF] py-3 text-sm lg:text-base">
											@if (isTS1) {
												TEM Safety Outcome
											} @else {
												TEM Training Effectiveness Ratings by Competency
											}
										</div>
										<app-cbta-ratings-progress-chart [data]="manueverChartData"></app-cbta-ratings-progress-chart>
									</div>
									@if (!isCC) {
										<div>
											<div class="mb-4 border-y border-[#CFE3FF] py-3 text-sm lg:text-base">Rating per Competency</div>
											<app-cbta-summary-radar-chart
												[labels]="ratingLabels"
												[datasets]="ratingDatasets"
											></app-cbta-summary-radar-chart>
										</div>
									}
								</mat-step>
							}
							<!-- STEP 3: Maneuver Breakdown -->
							<mat-step>
								<ng-container>
									@if (maneuvers.length > 0) {
										<mat-accordion [multi]="true">
											@for (m of maneuvers.controls; track $index; let i = $index) {
												<mat-expansion-panel class="mat-elevation-z1 maneuver-expansion-panel" [expanded]="true">
													<!-- Header -->
													@if (!isTS6 && !isTS1) {
														<mat-expansion-panel-header #panelH>
															<div class="ml-4">
																{{ $safeNavigationMigration(fixedManeuvers[i]?.subDescription) | uppercase }}
																<span class="ml-5">
																	<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
																	{{ fixedManeuvers[i]?.description }}
																</span>
															</div>
														</mat-expansion-panel-header>
													} @else if (isTS1) {
														<mat-expansion-panel-header #panelH class="maneuver-title">
															<mat-panel-title class="mat-panel-inner-title w-full">
																<div class="mt-6 flex justify-between" (click)="panelH._toggle()">
																	<!-- TS-1 header title -->
																</div>
																<div
																	class="mb-label flex items-center justify-start bg-blue-20 px-8 text-2xl font-medium italic text-black lg:bg-violet-light lg:text-violet"
																>
																	Maneuver {{ i + 1 }}:
																	{{
																		meneuverNameList[i] || maneuvers.at(i).get("maneuver")?.value?.description || "-"
																	}}
																</div>
															</mat-panel-title>
														</mat-expansion-panel-header>
													}
													<!-- Body -->
													<app-maneuver-form
														[expensionShow]="showExpansion($any(maneuvers.at(i)))"
														maneuverAction="create-form"
														[isManeuverVisible]="false"
														[maneuverForm]="$any(maneuvers.at(i))"
													>
													</app-maneuver-form>
												</mat-expansion-panel>
											}
										</mat-accordion>
									} @else {
										<div class="p-6 italic text-gray-500">No maneuvers available.</div>
									}
								</ng-container>
							</mat-step>
						</mat-stepper>
						<div class="mt-[40px] flex items-center gap-4 px-6">
							<button
								[disabled]="stepper.selectedIndex === 0"
								(click)="goBack(stepper)"
								mat-stroked-button
								class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black disabled:opacity-50"
							>
								Back
							</button>
							<button
								(click)="goNext(stepper)"
								mat-stroked-button
								class="min-w-[63px] border !border-b-2 !border-[#D9DBE0] !text-black"
							>
								Next
							</button>
							<div class="flex-1"></div>
						</div>
					}
				</app-cbta-form-navigator>
			}
		</div>
	</div>
} @else {
	<div class="italic text-gray-500">No candidates selected.</div>
}
